import { Heart, Sparkles, Leaf, Palette } from "lucide-react";

const BADGES = [
  { icon: Heart, label: "Premium Quality Ingredients", color: "var(--pink)" },
  { icon: Leaf, label: "Handmade with Love", color: "var(--blue-soft)" },
  { icon: Sparkles, label: "Made to Celebrate", color: "var(--pink)" },
  { icon: Palette, label: "Fun & Delicious Colors", color: "var(--blue-soft)" },
];

export default function StickerBadges() {
  return (
    <div className="grid grid-cols-2 gap-4 md:grid-cols-4" data-testid="sticker-badges">
      {BADGES.map(({ icon: Icon, label, color }, i) => (
        <div key={label} className="rise flex flex-col items-center gap-3 text-center" style={{ animationDelay: `${i * 90}ms` }}>
          <span className="flex h-16 w-16 items-center justify-center rounded-full border-[3px] bg-black" style={{ borderColor: color }}>
            <Icon className="h-7 w-7" style={{ color, fill: color }} />
          </span>
          <span className="text-sm font-extrabold leading-tight text-white/85">{label}</span>
        </div>
      ))}
    </div>
  );
}

export const Sparkle = ({ className = "", color = "var(--pink)", delay = 0 }) => (
  <svg viewBox="0 0 24 24" className={`twinkle absolute ${className}`} style={{ animationDelay: `${delay}s` }} aria-hidden>
    <path d="M12 0 L14 10 L24 12 L14 14 L12 24 L10 14 L0 12 L10 10 Z" fill={color} />
  </svg>
);
